<template>
  <el-header>
    <!-- 电脑端 -->
    <div v-if="mobile == 0">
      <img class="lenovo" :src="logoImgUrl" alt />
      <div class="user-img">
        <!-- <el-avatar icon="el-icon-user-solid"></el-avatar> -->
      </div>
      <div class="header-right" v-if="$route.path == '/'">
        <el-link
          class="go-link"
          v-on:click="lenovoLogin()"
          :disabled="isBannerVisible"
          type="primary"
        >{{$t("home.login")}}</el-link>
        <el-link
          class="go-link"
          v-on:click="register()"
          :disabled="isBannerVisible"
          type="primary"
        >{{$t("home.register")}}</el-link>
        <el-link v-if="!$isGlobal" class="go-link" v-on:click="goHelp" type="primary">{{$t("home.help")}}</el-link>
      </div>
    </div>
    <!-- 手机端 -->
    <div v-else class="Android">
      <img class="lenovo" :src="logoImgUrlMobile" alt />
      <div class="header-right" v-if="$route.path == '/'">
        <el-link
          class="go-link"
          v-on:click="lenovoLogin()"
          :disabled="isBannerVisible"
          type="primary"
        >{{$t("home.login")}}</el-link>
        <!-- <el-link class="go-link" v-on:click="register()" :disabled="isBannerVisible" type="primary">{{$t("home.register")}}</el-link> -->
        <el-link v-if="!$isGlobal" class="go-link" v-on:click="goHelp" type="primary">{{$t("home.help")}}</el-link>
      </div>
    </div>
  </el-header>
</template>
<script>
export default {
  name: 'Header',
  props: ['mobile'],
  data () {
    // 这里存放数据
    return {
      logoImgUrl: require('../../assets/logo_' + this.$i18n.locale + '.png'),
      logoImgUrlMobile: require('../../assets/mobile/logo_' + this.$i18n.locale + '.png'),
      locationUrl: location.protocol + '//' + location.hostname,
      // locationUrl:"https://global-test.lenovomm.cn/",
      accountPage: '/account-page/',
      isBannerVisible: false
    }
  },
  methods: {
    async lenovoLogin () {
      // 如果横幅显示，阻止登录
      if (this.isBannerVisible) {
        return
      }
      try {
        let res = await this.$http.accountinfoGeo()
        // console.log(res, 'res')
        if (res.data.idc.toLowerCase() !== 'cn') {
          window.location.href = location.protocol + '//' + location.hostname + '/glbwebauthnv6/gateway?lenovoid.action=uilogin&lenovoid.realm=homesite.passport.lenovo.com&lenovoid.lang=' + this.$i18n.locale + '&lenovoid.cb=' + location.protocol + '//' + location.hostname + '/account-page/?idc=' + res.data.idc
        } else {
          window.location.href = location.protocol + '//' + location.hostname + '/cnwebauthnv3/gateway?lenovoid.action=uilogin&lenovoid.realm=homesite.passport.lenovo.com&lenovoid.lang=' + this.$i18n.locale + '&lenovoid.cb=' + location.protocol + '//' + location.hostname + '/account-page/?idc=' + res.data.idc
        }
      } catch (e) {
        window.location.href = location.protocol + '//' + location.hostname + '/glbwebauthnv6/gateway?lenovoid.action=uilogin&lenovoid.realm=homesite.passport.lenovo.com&lenovoid.lang=' + this.$i18n.locale + '&lenovoid.cb=' + location.protocol + '//' + location.hostname + '/account-page/'
      }
    },
    async register () {
      // 如果横幅显示，阻止注册
      if (this.isBannerVisible) {
        return
      }
      try {
        let res = await this.$http.accountinfoGeo()
        // console.log(res, 'res')
        if (res.data.idc.toLowerCase() !== 'cn') {
          window.location.href = location.protocol + '//' + location.hostname + '/glbwebauthnv6/gateway?lenovoid.action=newaccount&lenovoid.realm=homesite.passport.lenovo.com&lenovoid.lang=' + this.$i18n.locale + '&lenovoid.cb=' + location.protocol + '//' + location.hostname + '/account-page/'
        } else {
          window.location.href = location.protocol + '//' + location.hostname + '/cnwebauthnv3/gateway?lenovoid.action=newaccount&lenovoid.realm=homesite.passport.lenovo.com&lenovoid.lang=' + this.$i18n.locale + '&lenovoid.cb=' + location.protocol + '//' + location.hostname + '/account-page/'
        }
      } catch (e) {
        window.location.href = location.protocol + '//' + location.hostname + '/glbwebauthnv6/gateway?lenovoid.action=newaccount&lenovoid.realm=homesite.passport.lenovo.com&lenovoid.lang=' + this.$i18n.locale + '&lenovoid.cb=' + location.protocol + '//' + location.hostname + '/account-page/'
      }
    },
    goHelp () {
      this.resetSetItem('isHelpView', 0)
      this.$router.push('/Help')
    }
  },
  computed: {
    uplanguage () {
      return this.$i18n.locale
    }
  },
  watch: {
    uplanguage (is) {
      var _this = this
      _this.logoImgUrl = require('../../assets/logo_' + this.$i18n.locale + '.png')
      _this.logoImgUrlMobile = require('../../assets/mobile/logo_' + this.$i18n.locale + '.png')
    }
  },
  mounted () {
    // 监听横幅状态变化事件
    this.$root.$on('cookieBannerStateChanged', (isVisible) => {
      this.isBannerVisible = isVisible
    })
  },
  beforeDestroy () {
    // 移除事件监听
    this.$root.$off('cookieBannerStateChanged')
  }
}
</script>
<style scoped lang="scss">
.lenovo {
  width: auto;
  vertical-align: middle;
  cursor: pointer;
  height: 25px;
  width: 105px;
}
.go-link {
  /* margin-top: 20%; */
  margin-right: 30px;
  font-size: 16px;
}
.go-link.is-disabled,
.go-link[disabled] {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}

.user-img {
  margin-top: 15px;
  float: right;
}
.header-right {
  float: right;
  color: #3e8ede;
  a:last-child {
    margin: 0;
  }
}
.el-header > div {
  padding: 0 10%;
  height: 100%;
}
.el-header {
  padding: 0;
  height: 72px !important;
  line-height: 72px;
  background-color: #ffffff;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 22px 2px rgba(89, 88, 88, 0.24);
}
.el-avatar {
  background-color: #128ee4;
}
.Android .header-right {
  float: right;
}
.el-header .Android {
  padding: 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/header.vue